export enum TooltipEvent {
  CLICK = 'click',
  HOVER = 'hover',
  PRESS = 'press'
}
